import * as Yup from "yup";
import { IFormField } from "../../helpers/interfaces/generic";

const msg_required = "Campo obbligatorio.";
const msg_min3 = "Minimo 3 caratteri.";
const msg_max60 = "Massimo 60 caratteri.";
const msg_code3 = "Deve essere esattamente di 3 caratteri.";

export function addActionFormFields(): Array<IFormField> {
  return [
    {
      label: 'Codice',
      name: 'code',
      type: 'text',
      class: 'form-control',
      validation: Yup.string().length(3, msg_code3).required(msg_required)
    },
    {
      label: 'Nome',
      name: 'name',
      type: 'text',
      class: 'form-control',
      validation: Yup.string().min(3, msg_min3).max(60, msg_max60).required(msg_required)
    }
  ];
}

export function editActionFormFields(): Array<IFormField> {
  return addActionFormFields();
}
